import Multimedia from "@stadium/ui/src/components/multimedia/multimedia";

const MultimediaWithFlag = (props) => {
  return <Multimedia {...props} isNextImage={false} />;
};

export default MultimediaWithFlag;
